import { getFreeTrialPropertiesAsync } from './getFreeTrialPropertiesAsync'

export const getFreeTrialSourceAsync = async (refresh = false) => {
  const { source } = await getFreeTrialPropertiesAsync(refresh)

  return source
}
